import styled from "styled-components";
import calender from "assets/images/calender.svg";

export const Container = styled.div`
  width: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  h1 {
    font-weight: 600;
  }

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  td {
    width: 18rem !important;
  }

  th {
    width: 18rem !important;
  }

  .th {
    width: 10rem !important;
  }

  .view-container {
    cursor: pointer;
  }

  .custom-date-input-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    position: relative;

    label {
      font-size: 1.4rem;
      font-weight: 500;
      color: var(--text);
      margin-bottom: 0;
      line-height: 1.4rem;
    }

    .date-input-wrapper {
      position: relative;
      width: 100%;

      /* Position calendar icon relative to the input wrapper */
      &::after {
        content: '';
        background-image: url(${calender});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 20px 20px;
        width: 20px;
        height: 20px;
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
        z-index: 1;
      }
    }

    .custom-date-input {
      position: relative;
      width: 100%;
    }

    /* Hide the global calendar icon since we're using the wrapper one */
    &::after {
      display: none !important;
    }
  }

  .search-container {
    align-items: flex-end;
    
    .input-fields {
      align-items: flex-end;
    }
  }

  .button-fields {
    display: flex;
    gap: 1.5rem;
    align-items: center;
    height: fit-content;
    margin-bottom: 0;
    
    @media (max-width: 990px) {
      width: 100%;
      justify-content: flex-start;
      margin-top: 1rem;
    }
  }
`;

